export function parseDuration(input: string): Date | null {
  const match = input
    .trim()
    .toLowerCase()
    .match(/^(\d+(?:\.\d+)?)\s*(s|m|h|d|w)$/);
  if (!match) return null;
  const amount = parseFloat(match[1]);
  const unit = match[2];
  const now = new Date();
  switch (unit) {
    case 's':
      now.setSeconds(now.getSeconds() - amount);
      break;
    case 'm':
      now.setMinutes(now.getMinutes() - amount);
      break;
    case 'h':
      now.setHours(now.getHours() - amount);
      break;
    case 'd':
      now.setDate(now.getDate() - amount);
      break;
    case 'w':
      now.setDate(now.getDate() - amount * 7);
      break;
    default:
      return null;
  }
  return now;
}

export function isValidDuration(input: string): boolean {
  return parseDuration(input) !== null;
}
